import i18n from '@/i18n'

export default [
    {
        value: 'one_year',
        text: i18n.t('careerObjective.period.one_year'),
        isDefault: true,
    },
    {
        value: 'two_years',
        text: i18n.t('careerObjective.period.two_years'),
        isDefault: false,
    },
    {
        value: 'three_years',
        text: i18n.t('careerObjective.period.three_years'),
        isDefault: false,
    },
    {
        value: 'four_years',
        text: i18n.t('careerObjective.period.four_years'),
        isDefault: false,
    },
    {
        value: 'five_years',
        text: i18n.t('careerObjective.period.five_years'),
        isDefault: false,
    },
]
